import { useState } from 'react';
import { HelpCircle, Book, Phone } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

export function HelpSupport() {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmitTicket = () => {
    console.log('Submit ticket:', { subject, message });
    setSubject('');
    setMessage('');
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Help & Support</CardTitle>
      </CardHeader>
      <CardContent className="space-y-8">
        {/* Quick Links */}
        <div className="grid gap-4 md:grid-cols-3">
          <button className="hover:bg-accent flex flex-col items-center gap-2 rounded-lg border p-6 transition-colors">
            <HelpCircle className="text-muted-foreground h-8 w-8" />
            <p className="font-medium">FAQs</p>
            <p className="text-muted-foreground text-center text-xs">View our FAQs</p>
          </button>

          <button className="hover:bg-accent flex flex-col items-center gap-2 rounded-lg border p-6 transition-colors">
            <Book className="text-muted-foreground h-8 w-8" />
            <p className="font-medium">Knowledge Base</p>
            <p className="text-muted-foreground text-center text-xs">Browse articles</p>
          </button>

          <button className="hover:bg-accent flex flex-col items-center gap-2 rounded-lg border p-6 transition-colors">
            <Phone className="text-muted-foreground h-8 w-8" />
            <p className="font-medium">Contact Support</p>
            <p className="text-muted-foreground text-center text-xs">
              helpdesk@example.com
              <br />
              1-800-555-HELP
              <br />
              24/7 Live Chat
            </p>
          </button>
        </div>

        {/* Submit Support Ticket */}
        <div>
          <h3 className="mb-4 text-lg font-semibold">Submit a Support Ticket</h3>
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="ticket-subject">Subject</Label>
              <Input
                id="ticket-subject"
                placeholder="e.g., Issue with property template"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="ticket-message">Message</Label>
              <Textarea
                id="ticket-message"
                placeholder="Describe your issue in detail..."
                rows={6}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>
            <div className="flex justify-end">
              <Button onClick={handleSubmitTicket}>Submit Ticket</Button>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
